import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile.jsx";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import VerifySuccess from "./pages/VerifySuccess";
import VerifyFailed from "./pages/VerifyFailed";

import Reels from "./pages/Reels";

import Messages from "./pages/Messages";

import WelcomeOnboarding from "./pages/WelcomeOnboarding";
import SyncContacts from "./pages/SyncContacts";
import EditProfile from "./pages/EditProfile";
import MediaViewer from "./pages/MediaViewer";
import PostView from "./pages/PostView";
import AddFriends from "./pages/onboarding/AddFriends";
import FriendRequests from "./pages/friends/FriendRequests";
import FriendsList from "./pages/friends/FriendsList";
import FriendSuggestions from "./pages/friends/FriendSuggestions";
import Wallet from "./pages/Wallet";
import Leaderboard from "./pages/Leaderboard";

import SavedPosts from "./pages/SavedPosts";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VerifyEmailSent from "./pages/VerifyEmailSent";

import SuggestedFriends from "./components/friends/SuggestedFriends";
import ReelsHorizontal from "./components/reels/ReelsHorizontal";

import Notifications from "./pages/Notifications";

import StoryMusicUploader from "./components/stories/StoryMusicUploader";
import AdminWithdrawals
from "./pages/admin/AdminWithdrawals";
import AdminDashboard
from "./pages/admin/AdminDashboard";
import AdminVerifications
from "./pages/admin/AdminVerifications";
import AdminCreators from "./pages/admin/AdminCreators";
import AdminAdvertisers from "./pages/admin/AdminAdvertisers";
import AdminBoosts from "./pages/admin/AdminBoosts";
import AdminCampaigns
from "./pages/admin/AdminCampaigns";
import AdminFraud
from "./pages/admin/AdminFraud";
import AdminRevenue
from "./pages/admin/AdminRevenue";
import AdminEarnings
from "./pages/admin/AdminEarnings";
import AdminWallet
from "./pages/admin/AdminWallet";
import AdminKyc from "./pages/admin/AdminKyc";
import CreatorDashboard
from "./pages/creator/CreatorDashboard";

import CreatorEarnings
from "./pages/creator/CreatorEarnings";

import ApplyMonetization
from "./pages/creator/ApplyMonetization";

import AdvertiserDashboard
from "./pages/ads/AdvertiserDashboard";

import ApplyAdvertiser
from "./pages/ads/ApplyAdvertiser";

import CreateCampaign
from "./pages/ads/CreateCampaign";
import SellerKyc from "./pages/SellerKyc";

import MyCampaigns
from "./pages/ads/MyCampaigns";

import PostComposer
from "./components/PostComposer";

import DiscoverFriends from "./pages/DiscoverFriends";

import FriendCarousel from "./components/friends/FriendCarousel";

import IncomingCallListener from "./features/calls/IncomingCallListener";
import IncomingCallModal
from "./features/calls/IncomingCallModal";
import CreateListing from "./pages/CreateListing";
import Marketplace from "./pages/Marketplace";
import MarketplaceListing from "./pages/MarketplaceListing";
import EditListing from "./pages/EditListing";
import MyListings from "./pages/MyListings";
import SavedListings from "./pages/SavedListings";
import Premium from "./pages/Premium";
import PaystackCallback from "./pages/PaystackCallback";
import StickerTest from "./pages/StickerTest";
import PKBattle from "./components/PKBattle";
import PKCreate from "./pages/PKCreate";
import PKHistory from "./pages/PKHistory";
import PKStats from "./pages/PKStats";
import AIMediaStudio from "./pages/AIMediaStudio";











function App() {
  console.log("API:", import.meta.env.VITE_API_BASE);

const location = useLocation();

const hideNavbar =
  location.pathname.startsWith("/messages") ||
  location.pathname.startsWith("/reels");



useEffect(() => {
  const preventDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const preventDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  // Block drag everywhere
  window.addEventListener("dragenter", preventDrag);
  window.addEventListener("dragover", preventDrag);

  // Block file opening on drop
  window.addEventListener("drop", preventDrop);

  return () => {
    window.removeEventListener("dragenter", preventDrag);
    window.removeEventListener("dragover", preventDrag);
    window.removeEventListener("drop", preventDrop);
  };
}, []);


 return (
    <HelmetProvider>
      
  {!hideNavbar && <Navbar />}


        <div className="min-h-[calc(100vh-80px)] w-full">
          
        
       <IncomingCallModal />
      <IncomingCallListener />
      

      <Routes>
            {/* PUBLIC */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />


            <Route
  path="/verify-email"
  element={<VerifyEmail />}
/>

<Route
  path="/verify-email/:token"
  element={<VerifyEmail />}
/>

<Route path="/verify-success" element={<VerifySuccess />} />
            <Route path="/verify-failed" element={<VerifyFailed />} />
            <Route path="/welcome" element={<WelcomeOnboarding />} />
            <Route path="/media/:postId" element={<MediaViewer />} />
            <Route path="/post/:id" element={<PostView />} />

<Route path="/verify-email-sent" element={<VerifyEmailSent />} />

<Route
  path="/admin/story-music"
  element={<AdminRoute><StoryMusicUploader /></AdminRoute>}
/>

 <Route
    path="/admin/withdrawals"
    element={<AdminRoute><AdminWithdrawals /></AdminRoute>}
  />


 
 <Route
    path="/admindashboard"
    element={<AdminRoute><AdminDashboard /></AdminRoute>}
  />

<Route
  path="/admin/verifications"
  element={<AdminRoute><AdminVerifications /></AdminRoute>}
/>

<Route
  path="/admin/creators"
  element={<AdminRoute><AdminCreators /></AdminRoute>}
/>

<Route
  path="/admin/advertisers"
  element={<AdminRoute><AdminAdvertisers /></AdminRoute>}
/>

<Route
  path="/admin/campaigns"
  element={<AdminRoute><AdminCampaigns /></AdminRoute>}
/>

<Route
  path="/admin/boosts"
  element={<AdminRoute><AdminBoosts /></AdminRoute>}
/>

<Route
  path="/admin/fraud"
  element={<AdminRoute><AdminFraud /></AdminRoute>}
/>


<Route path="/admin/earnings" element={<AdminRoute><AdminEarnings /></AdminRoute>} />
<Route path="/admin/revenue" element={<AdminRoute><AdminRevenue /></AdminRoute>} />
<Route path="/admin/wallet" element={<AdminRoute><AdminWallet /></AdminRoute>} />
        <Route path="/admin/kyc" element={<AdminRoute><AdminKyc /></AdminRoute>} />
<Route
  path="/creator"
  element={<CreatorDashboard />}
/>

<Route
  path="/creator/earnings"
  element={<CreatorEarnings />}
/>

<Route
  path="/creator/apply"
  element={<ApplyMonetization />}
/>

<Route
  path="/ads"
  element={<AdvertiserDashboard />}
/>

<Route
  path="/ads/apply"
  element={<ApplyAdvertiser />}
/>

<Route
  path="/ads/create"
  element={<CreateCampaign />}
/>

<Route
  path="/ads/campaigns"
  element={<MyCampaigns />}
/>

<Route
  path="/create-post"
  element={
    <PostComposer
      
    />}
  
/>

<Route
  path="/marketplace/create"
  element={<CreateListing />}
/>

<Route
    path="/sticker-test"
    element={<StickerTest />}
/>

<Route
  path="/pk/create"
  element={
    <ProtectedRoute>
      <PKCreate />
    </ProtectedRoute>
  }
/>

<Route
  path="/pk/:battleId"
  element={
    <ProtectedRoute>
      <PKBattle />
    </ProtectedRoute>
  }
/>


<Route
  path="/pk/history"
  element={
    <PKHistory />
  }
/>

<Route
  path="/pk/stats"
  element={
    <PKStats />
  }
/>


<Route
  path="/ai-media"
  element={
    <ProtectedRoute>
      <AIMediaStudio />
    </ProtectedRoute>
  }
/>




            {/* PROTECTED */}
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/profile/:userId" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            
            <Route path="/reels" element={<ProtectedRoute><Reels /></ProtectedRoute>} />
            <Route
  path="/messages/:id?"
  element={
    <ProtectedRoute>
      <Messages />
    </ProtectedRoute>
  }
/>

<Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />

            <Route path="/add-friends" element={<ProtectedRoute><AddFriends /></ProtectedRoute>} />
            <Route path="/sync-contacts" element={<ProtectedRoute><SyncContacts /></ProtectedRoute>} />
            <Route path="/edit-profile" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
            <Route path="/friend-requests" element={<ProtectedRoute><FriendRequests /></ProtectedRoute>} />
            <Route path="/friends" element={<ProtectedRoute><FriendsList /></ProtectedRoute>} />


<Route
  path="/friends/discover"
  element={
    <ProtectedRoute>
      <DiscoverFriends />
    </ProtectedRoute>
  }
/>

<Route
  path="/friends/explore"
  element={
    <ProtectedRoute>
      <FriendCarousel />
    </ProtectedRoute>
  }
/>

<Route
  path="/suggested-friends"
  element={
    <ProtectedRoute>
      <SuggestedFriends />
    </ProtectedRoute>
  }
/>

<Route
  path="/reelshorizontal"
  element={
    <ProtectedRoute>
      <ReelsHorizontal />
    </ProtectedRoute>
  }
/>

<Route path="/leaderboard" element={<Leaderboard />} />
            
            <Route
              path="/saved"
              element={
                <ProtectedRoute>
                  <SavedPosts />
                </ProtectedRoute>
              }
            />

    <Route
      path="/notifications"
              element={
                <ProtectedRoute>
                  <Notifications/>
                </ProtectedRoute>
              }
            />


<Route
  path="/marketplace"
  element={
    <ProtectedRoute>
      <Marketplace />
    </ProtectedRoute>
  }
/>

<Route
  path="/marketplace/create"
  element={
    <ProtectedRoute>
      <CreateListing />
    </ProtectedRoute>
  }
/>

<Route
  path="/marketplace/my-listings"
  element={
    <ProtectedRoute>
      <MyListings />
    </ProtectedRoute>
  }
/>

<Route
  path="/marketplace/saved"
  element={
    <ProtectedRoute>
      <SavedListings />
    </ProtectedRoute>
  }
/>

        <Route
  path="/payment/paystack/callback"
  element={
    <ProtectedRoute>
      <PaystackCallback />
    </ProtectedRoute>
  }
/>

<Route
  path="/premium"
  element={
    <ProtectedRoute>
      <Premium />
    </ProtectedRoute>
  }
/>
<Route
  path="/marketplace/kyc"
  element={
    <ProtectedRoute>
      <SellerKyc />
    </ProtectedRoute>
  }
/>


<Route
  path="/marketplace/:id"
  element={
    <ProtectedRoute>
      <MarketplaceListing />
    </ProtectedRoute>
  }
/>

<Route
  path="/marketplace/:id/edit"
  element={
    <ProtectedRoute>
      <EditListing />
    </ProtectedRoute>
  }
/>

</Routes>
        </div>

        {/* Toast MUST be inside Router but OUTSIDE Routes */}
        <ToastContainer position="bottom-center" />

      
    </HelmetProvider>
  );
}

export default App;